import React from 'react';
import ProgrammeCardItem from './ProgrammeCardItem';
import './Cards.css';

function ProgrammeCards() {
  return (
    <div className='cards2'>
        <div className="cards__container">
            <div className="cards__wrapper">
                <ul className="cards__items">
                    <ProgrammeCardItem 
                    src="images/little-engineer.jpg"
                    text="Explore Scratch Junior and simple mechanics with Lego Technic to spark curiosity and early coding skills."
                    label='Kinder (4-6)'
                    path='/kinder'
                    navigate='/kinder'
                    />
                    <ProgrammeCardItem 
                    src="images/child-making-robot.jpg"
                    text="Dive into Scratch, mechanics, and machine learning with Wedo to build a solid foundation in STEM."
                    label='Junior (6-8)'
                    path='/junior'
                    navigate='/junior'
                    />
                    <ProgrammeCardItem 
                    src="images/build-robot.jpg"
                    text="Master advanced Scratch, mechanics, and machine learning with Wedo for a deeper understanding of technology."
                    label='Coder (8-10)'
                    path='/coder'
                    navigate='/coder'
                    />
                </ul>
            </div>
        </div>
    </div>
  )
}

export default ProgrammeCards
